
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class HelpDialog extends Vue {
  @Prop({ default: false }) visible!: boolean

  flag = 0

  closeDialog() {
    this.$emit('update:visible', false)
  }

  afterClose() {
    this.flag = 0
  }

  jump() {
    window.open('/categories')
  }
}
